import { Table as KitchensinkTable, Button } from '@bdo/kitchensink';
import React from 'react';
import { appRoutes, buildAppRoute } from '../../config/appRoutes';
import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import moment from 'moment';

export default function Table({ isLoading, records, pagination, onTableChange, ...props }) {
    const navigate = useNavigate();        
    const columns = [
        {
            title: 'Title',
            key: 'title',
            dataIndex: 'title'
        },
        {
            title: 'Template',
            key: 'templateName',
            render: (record) => (
                <Link to={buildAppRoute(appRoutes.template.view, { id: record.templateId })} target="_blank">
                    {record.templateName}
                </Link>
            )
        },
        {
            title: 'Date created',
            key: 'createdDate',
            dataIndex: 'createdDate',
            render: (record) => (moment(record).format('DD MMM YYYY')),
            sortOrder: pagination?.sort,
            sorter: true,
        },
        {
            title: 'Global Portal',
            dataIndex: 'allowGlobalPortalResponses',
            key: 'allowGlobalPortalResponses',
            render: (record) => (record === true ? "Yes" : "No")
        },
        {
            title: 'Passcode',
            dataIndex: 'allowPasscodeResponses',
            key: 'allowPasscodeResponses',
            render: (record) => (record === true ? "Yes" : "No")
        },
        {
            title: 'Anonymous',
            dataIndex: 'allowAnonymousResponses',
            key: 'allowAnonymousResponses',
            render: (record) => (record === true ? "Yes" : "No")
        },              
        {
            title: 'Archived',
            dataIndex: 'isArchived',
            key: 'isArchived',
            render: (record) => (record === true ? "Yes" : "No")
        },
        {
            title: 'Actions',
            key: 'actions',
            render: (record) => (
                <>
                    <Button type='primary' onClick={() => navigate(buildAppRoute(appRoutes.capture.manage, { captureName: record?.title, captureId: record?.id }), { state: { capturesPagination: pagination } })}>
                        Manage
                    </Button>
                </>
            )
        }
    ];
    
    return (
        <>
            <KitchensinkTable
                columns={columns}
                loading={isLoading}
                dataSource={records}
                rowKey='id'                
                pagination={pagination}
                onChange={onTableChange}
                {...props}
            />
        </>
    );

}

